import React from 'react';

import './i18n';
import App from './AppContainer.jsx';

const ReactSPA = ({ data }) => <App initData={data} />;

export default ReactSPA;
